"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countUniqueParticipantsFromPost = exports.countUniqueParticipantsFromPosts = void 0;
var ObjectId_1 = require("./ObjectId");
var addAuthorId = function (ids, author) {
    if (!author || typeof author === 'string')
        return;
    if (author._id)
        ids.add(author._id);
};
/** Unique topic authors + comment authors across one or more posts. */
var countUniqueParticipantsFromPosts = function (posts) {
    if (!(0, ObjectId_1.isArrayPopulated)(posts))
        return 0;
    var ids = new Set();
    for (var _i = 0, _a = posts; _i < _a.length; _i++) {
        var post = _a[_i];
        if (typeof post === 'string')
            continue;
        addAuthorId(ids, post.author);
        if (!(0, ObjectId_1.isArrayPopulated)(post.comments))
            continue;
        for (var _b = 0, _c = post.comments; _b < _c.length; _b++) {
            var comment = _c[_b];
            if (typeof comment === 'string')
                continue;
            addAuthorId(ids, comment.author);
        }
    }
    return ids.size;
};
exports.countUniqueParticipantsFromPosts = countUniqueParticipantsFromPosts;
var countUniqueParticipantsFromPost = function (post) { return (0, exports.countUniqueParticipantsFromPosts)([post]); };
exports.countUniqueParticipantsFromPost = countUniqueParticipantsFromPost;
//# sourceMappingURL=forumParticipants.js.map